import React from "react";
import BlockTitle from "./BlockTitle";

import CtaShape1 from "../assets/images/shapes/cta-1-shape-1.png";
import CtaShape2 from "../assets/images/shapes/cta-1-shape-2.png";
import CtaMoc1 from "../assets/images/resources/cta-1-moc-1.png";

const CTAOne = () => {
  return (
    <section className="cta-one" id="sistema">
      <img src={CtaShape1} className="cta-one__bg-shape-1" alt="awesome post" />
      <img src={CtaShape2} className="cta-one__bg-shape-2" alt="awesome post" />
      <div className="container">
        <div className="cta-one__moc wow fadeInLeft" data-wow-duration="1500ms">
          <img src={CtaMoc1} className="cta-one__moc-img" alt="awesome post" />
        </div>
        <div className="row justify-content-end">
          <div className="col-lg-6">
            <div className="cta-one__content">
              <BlockTitle
                textAlign="left"
                paraText="Avante Web"
                titleText={`Sistema Comercial\nGestão desde qualquer lugar`}
              />
              <div className="cta-one__text">
                <p>
                Emissão ilimitada de Notas e Documentos fiscais
                Vinculado a todas as Prefeituras e Estados do Brasil.
                </p>
              </div>
              <ul className="list-unstyled cta-one__list">
                <li>
                  <i className="fa fa-check-circle"></i>
                  Venda, Pedido de Venda, Venda Futura, Orçamento
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  Controle Fiscal (Sintegra)
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  Controle financeiro
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  Controle de Estoque
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  Integração gratuita com a sua contabilidade
                </li>
              </ul>
              <a href="https://api.whatsapp.com/send?phone=5566996866082&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20sistema" target='_blank' className="thm-btn cta-one__btn">
                <span>Quero Saber Mais</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAOne;
